import axios from "axios";
import { BaseUrl } from "../env";
// import store from "../store/index";
// import { logoutSlice } from "../store/slice/auth";

export const instanceAxios = axios.create({
    baseURL: BaseUrl
});

instanceAxios.interceptors.response.use(function (response) {
    if (response.config.url === `/login` || response.config.url === `/refresh-token`) {
        const auth = response.data
        instanceAxios.defaults.headers.common['Authorization'] = 'Bearer ' + auth.token;
    }
    return response;
}, function (error) {
    const statusCode = error.response.status
    if (statusCode === 401 || statusCode === 404) {
        // store.dispatch(logoutSlice())
    }
    return Promise.reject(error);
});

export const setCredentialRequest = ({ token }: { token: string | null }) => {
    return new Promise((resolve, reject) => {
        instanceAxios.defaults.headers.common['Authorization'] = token !== null ? 'Bearer ' + token : null;
        resolve(true)
    })
}